import { render, staticRenderFns } from "./SitesWaysTable.vue?vue&type=template&id=1aed3816&scoped=true"
import script from "./SitesWaysTable.vue?vue&type=script&lang=js"
export * from "./SitesWaysTable.vue?vue&type=script&lang=js"
import style0 from "./SitesWaysTable.vue?vue&type=style&index=0&id=1aed3816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed3816",
  null
  
)

export default component.exports